import { proxy, snapshot, useSnapshot } from "@web-monorepo/hooks";

export type ToolkitRealtimeState = {
  paired: boolean;
  displayOn: boolean;
};

function createInitialState(): ToolkitRealtimeState {
  return {
    paired: false,
    displayOn: false,
  };
}

const store = proxy<ToolkitRealtimeState>(createInitialState());

export const toolkitRealtimeActions = {
  setPaired(paired: boolean) {
    store.paired = paired;

    if (!paired) {
      store.displayOn = false;
    }
  },

  setDisplayOn(displayOn: boolean) {
    store.displayOn = displayOn;
  },
};

export function useToolkitRealtimeStore() {
  return useSnapshot(store);
}

export function getToolkitRealtimeState() {
  return snapshot(store);
}

export function resetToolkitRealtimeStore() {
  Object.assign(store, createInitialState());
}
